<template>
  <div class="d-flex align-center">
    <!-- نمایش نتیجه -->
    <div v-if="result" class="mr-3 d-flex gap-2">
      <v-chip color="success" outlined small>
        حداقل: {{ formatPrice(result.min) }}
      </v-chip>
      <v-chip color="error" outlined small>
        حداکثر: {{ formatPrice(result.max) }}
      </v-chip>
    </div>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn          
          :loading="isLoading"
          v-bind="attrs"
          v-on="on"
          @click="calculatePrice"
          class="btn-buy elevation-5 rounded-pill ma-0 pa-1"
        >
          <v-icon>mdi-calculator</v-icon>
        </v-btn>
      </template>
      <span>محاسبه بازه قیمت نهایی</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "PriceCalculator",
  props: {
    // مشخص‌کننده حالت پک (چند محصولی)
    pack: {
      type: Boolean,
      default: false
    },
    // لیست اقلام در صورت پک بودن
    components: {
      type: Array,
      default: () => []
    },
    // فیلدهای اختصاصی حالت تکی (ساده)
    productId: {
      type: [Number, String],
      default: null
    },
    skuId: {
      type: [Number, String],
      default: null
    },
    formData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      result: null,
    };
  },
  methods: {
    formatPrice(val) {
      if (!val) return '0';
      return Number(val).toLocaleString('fa-IR');
    },
    async calculatePrice() {
      // اعتبارسنجی اولیه فرم
      if (!this.formData.package_cost || !this.formData.price_step) {
        this.$toast?.warning("لطفا هزینه بسته‌بندی و گام قیمت را وارد کنید.");
        return;
      }

      // اعتبارسنجی بر اساس حالت پک یا ساده
      if (this.pack) {
        if (!this.components || !this.components.length) {
          this.$toast?.warning("لطفا آیتم‌های پک را مشخص کنید.");
          return;
        }
      } else {
        if (!this.productId) {
          this.$toast?.warning("لطفا ابتدا محصول سامانه را انتخاب کنید.");
          return;
        }
      }

      this.isLoading = true;
      this.result = null;

      try {
        const payload = {
          package_quantity: Number(this.formData.package_quantity) || 1,
          package_cost: Number(String(this.formData.package_cost).replace(/,/g, '')),
          shipping_method: this.formData.shipping_method,
          price_step: Number(String(this.formData.price_step).replace(/,/g, ''))
        };

        if (this.pack) {
          // حالت پک: اضافه شدن لیست components
          payload.components = this.components.map(item => ({
            product_id: Number(item.product_id),
            sku_id: item.sku_id ? Number(item.sku_id) : null,
            quantity: Number(item.quantity) || 1
          }));
        } else {
          // حالت ساده: فیلدهای تکی محصول
          payload.product_id = Number(this.productId);
          if (this.skuId) {
            payload.product_sku_id = Number(this.skuId);
          }
        }

        const response = await this.$api.post('/v1/marketplace-listings/digi/final-price', payload);
        const data = response.data?.data || response.data;
        
        this.result = {
          min: data.final_price_min || 0,
          max: data.final_price_max || 0
        };

      } catch (error) {
        this.$toast?.error(error.response?.data?.message || "خطا در محاسبه قیمت");
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}
</style>
